import React from "react";

function Companynew() {
  return (
    <div>
      <div className="visa-bg">
        <div className="fables-after-overlyy">
          <div className="container py-3">
            <div className="headings1 mb-5">
              <h6 className="subtitle text-center">Inter Market Knit</h6>
              <h2 className="main-heading text-center text-light">
                Where Expertise Team Up With Latest Technology
              </h2>
            </div>
            <div className="row g-4 justify-content-center">
                <div className="col-md-9 ">
            <p className="text-light"> 
              At INTER MARKET KNIT, we blend expertise with the latest
              technology to craft a range of products exactly suited for your
              company and lifestyle. Whether you're an athlete pushing your
              limits, an outdoor enthusiast exploring the great outdoors, or
              someone who simply demands the best from their gear, we have you
              covered. - Here's what sets us apart:
            </p>

                </div>
              {/* {/ new addition start /} */}
              <div className="col-md-4 visa-mig-col">
                <h5 className="text-center py-2" style={{ color: '#f1f1f1', fontWeight: '700', backgroundColor: 'var(--secondary-color)', display: ''}}>A Team With Unrivaled Expertise</h5>
                <p className="text-white mt-3">
                With years of experience in product development, our designers and technicians ensure that every pair of socks meets the highest standards of requirement.
                </p>
              </div>
              <div className="col-md-4">
              <h5 className="text-center py-2" style={{ color: '#f1f1f1', fontWeight: '700', backgroundColor: 'var(--secondary-color)', display: ''}}>Cutting-Edge Technology</h5>
                <p className="mt-3 text-light">
                Our 230 advanced socks knitting machines and innovative manufacturing processes enable us to deliver products that are not only durable and comfortable but also optimized for performance in any environment.
                </p>
               
              </div>
              <div className="col-md-4 visa-mig-col">
              <h5 className="text-center py-2" style={{ color: '#f1f1f1', fontWeight: '700', backgroundColor: 'var(--secondary-color)', display: ''}}>Production Capacity</h5>
                <p className="mt-3 text-light">
                With our state-of-the-art machinery and efficient processes, we have a production capacity of 200,000 dozen pairs per month, ensuring that we can meet even the most demanding requirements with ease.
                </p>
                
              </div>
              <div className="col-md-4">
              <h5 className="text-center py-2" style={{ color: '#f1f1f1', fontWeight: '700', backgroundColor: 'var(--secondary-color)', display: ''}}>Quality Assurance</h5>
                <p className="mt-3 text-light">
                Quality is our top priority. That's why we are certified by industry-leading organizations such as OEKOTEX, SA800, WRAP, SEDEX/SMETA, ISO9001-2015, ISO45001-2018, BCI, and GOTS (In Process), ensuring that our socks adhere to the strictest standards of excellence.
                </p>
                
              </div>
              <div className="col-md-4 visa-mig-col">
              <h5 className="text-center py-2" style={{ color: '#f1f1f1', fontWeight: '700', backgroundColor: 'var(--secondary-color)', display: ''}}>Global Presence</h5>
                <p className="mt-3 text-light">
                Serving markets across Europe, UK, USA, and the Gulf, we understand the diverse needs of customers worldwide and tailor our products to meet those requirements.
                </p>
                
              </div>
              <div className="col-md-4">
              <h5 className="text-center py-2" style={{ color: '#f1f1f1', fontWeight: '700', backgroundColor: 'var(--secondary-color)', display: ''}}>Trusted By Leading Brands</h5>
                <p className="mt-3 text-light">
                Our commitment to excellence has earned us partnerships with industry-leading brands such as HEMA, POUNDLAND UK, PEP&CO., PATRICK, UHL SPORT, Tamasu Butterfly, Safety Joggers, ENGEL, JAKO, U.S. POLO ASSN, MATALAN, ALDI and INTERSPORT.
                </p>
              </div>
              <div className="col-md-4">
              <h5 className="text-center py-2" style={{ color: '#f1f1f1', fontWeight: '700', backgroundColor: 'var(--secondary-color)', display: ''}}>	Specialization In Performance Socks</h5>
                <p className="mt-3 text-light">
                From moisture-wicking materials to strategic cushioning and support, our performance socks are designed to enhance your comfort and support your performance every step of the way.
                </p>
              </div>
              <div className="col-md-4">
              <h5 className="text-center py-2" style={{ color: '#f1f1f1', fontWeight: '700', backgroundColor: 'var(--secondary-color)', display: ''}}>	Expertise In Wool Socks & Safety Sleeves</h5>
                <p className="mt-3 text-light">
                We take pride in our specialization in wool products and safety sleeves. Our wool items offer unparalleled warmth, comfort, and durability, while our safety sleeves are designed to provide optimal protection in demanding environments.
                </p>
              </div>
              <div className="col-md-4">
              <h5 className="text-center py-2" style={{ color: '#f1f1f1', fontWeight: '700', backgroundColor: 'var(--secondary-color)', display: ''}}>	Flexible Collaboration</h5>
                <p className="mt-3 text-light">
                We understand that every partnership is unique. That's why we offer flexible minimum order quantities and competitive pricing, ensuring that you get exactly what you need, when you need it.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Companynew;
